export default function () {
    let fn = function () {
        let width = document.documentElement.clientWidth;
        document.documentElement.style.fontSize = width / 750 * 40 + 'px'
        if (width>750) {
            document.documentElement.style.fontSize = 24 + 'px'
        }
    }
    fn()
    window.addEventListener('resize', fn, false)
}



// WEBPACK FOOTER //
// ./src/utils/rem.js